import Vue from 'vue';

function config(accessToken) {
  return { headers: { Accept: 'application/json', Authorization: 'Bearer ' + accessToken } };
}

export async function listarAutorizacionesTarjeta(accessToken, reservaId) {
  const response = await Vue.axios.get(`/reservas/${reservaId}/autorizaciones-tarjeta`, config(accessToken));
  return response.data.data;
}

export async function enviarAutorizacionesTarjeta(accessToken, reservaId, pasajeros, correo = {}) {
  const response = await Vue.axios.post(`/reservas/${reservaId}/autorizaciones-tarjeta/enviar`, { pasajeros, ...(Object.keys(correo).length ? { correo } : {}) }, config(accessToken));
  return response.data;
}

export async function obtenerAutorizacionTarjeta(accessToken, reservaId, id) {
  const response = await Vue.axios.get(`/reservas/${reservaId}/autorizaciones-tarjeta/${id}`, config(accessToken));
  return response.data.data;
}
